import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { InputAdornment, TextField } from '@mui/material';
import ContentCopy from '@mui/icons-material/ContentCopy';
import { toast } from 'react-hot-toast';

type Row = {
  host: string;
  type: string;
  data: string;
};
export function DnsRecordsTable({ rows }: { rows: Row[] }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Host name</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell>{row.type}</TableCell>
              <TableCell>
                <ReadOnlyTextField value={row.host} />
              </TableCell>
              <TableCell>
                <ReadOnlyTextField value={row.data} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function CaaAmazonRecordsTable() {
  return (
    <TableContainer component={Paper} sx={{ maxWidth: 'max-content' }}>
      <Table
        sx={{ maxWidth: 'max-content', paddingTop: '16px', overflow: 'scroll' }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Flag</TableCell>
            <TableCell>Tag</TableCell>
            <TableCell sx={{ width: 'max-content' }}>CA domain</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>CAA</TableCell>
            <TableCell>@</TableCell>
            <TableCell>0</TableCell>
            <TableCell>issue</TableCell>
            <TableCell sx={{ width: 'max-content' }}>
              <ReadOnlyTextField value="amazon.com" />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>CAA</TableCell>
            <TableCell>@</TableCell>
            <TableCell>0</TableCell>
            <TableCell>issuewild</TableCell>
            <TableCell sx={{ width: 'max-content' }}>
              <ReadOnlyTextField value="amazon.com" />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function ReadOnlyTextField({ value }: { value: string }) {
  const handleCopy = React.useCallback(() => {
    navigator.clipboard.writeText(value);
    toast.success('Copied to clipboard');
  }, [value]);

  return (
    <TextField
      className="w-full"
      value={value}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment
            className="cursor-pointer"
            position="end"
            onClick={handleCopy}
          >
            <ContentCopy fontSize="small" color="primary"></ContentCopy>
          </InputAdornment>
        ),
      }}
    ></TextField>
  );
}
